'use client';

import React, { Fragment, useContext, useEffect } from 'react';
import { Transition, TransitionChild } from '@headlessui/react';
import { WindowWithGtag } from '@/features/analytics/types';
import { AppNextLink } from '@/features/app-next-link';
import { Button } from '@/features/button';
import { IconClose, IconCookie } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { useMounted } from '@/utils/use-mounted';
import { CookieConsentContext } from './cookie-consent-context';
import { CookieConsentValues } from './type';
declare const window: WindowWithGtag;
const CookieConsentModal = () => {
  const {
    isMobile
  } = useMobileDetect();
  const isMounted = useMounted();
  const {
    fireAllCallbacks,
    closeConsentModal,
    isConsentModalOpen,
    changeCookieConsentHander
  } = useContext(CookieConsentContext);
  const onDenied = () => {
    changeCookieConsentHander(CookieConsentValues.Denied);
    closeConsentModal();
    fireAllCallbacks();
  };
  const onGranted = () => {
    changeCookieConsentHander(CookieConsentValues.Granted);
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
      });
    }
    closeConsentModal();
    fireAllCallbacks();
  };
  useEffect(() => {
    if (!isConsentModalOpen) return;
    setTimeout(() => {
      document.documentElement.style.overflow = '';
      document.documentElement.style.paddingRight = '';
    });
  }, [isConsentModalOpen]);
  if (!isMounted) return null;
  return <Transition appear show={isConsentModalOpen} as={Fragment} data-sentry-element="Transition" data-sentry-component="CookieConsentModal" data-sentry-source-file="cookie-consent-modal.tsx">
            <div className='z-top-of-chatbot-plus3 relative flex justify-center'>
                <TransitionChild as={Fragment} enter='ease-out duration-300' enterFrom='opacity-0' enterTo='opacity-100' leave='ease-in duration-200' leaveFrom='opacity-100' leaveTo='opacity-0' data-sentry-element="TransitionChild" data-sentry-source-file="cookie-consent-modal.tsx">
                    <div className='fixed inset-0 bg-black bg-opacity-25' />
                </TransitionChild>

                <TransitionChild as={Fragment} enter='lg:ease-out lg:duration-300 transition ease duration-300 transform lg:transform-none' enterFrom='lg:opacity-0 lg:scale-95 translate-y-full' enterTo='lg:opacity-100 lg:scale-100 opacity-100 translate-y-0' leave='lg:ease-in lg:duration-200 transition ease duration-200 transform lg:transform-none' leaveFrom='lg:opacity-100 lg:scale-100 opacity-100 translate-y-0' leaveTo='lg:opacity-0 lg:scale-95 translate-y-full' data-sentry-element="TransitionChild" data-sentry-source-file="cookie-consent-modal.tsx">
                    <div className='fixed bottom-0 w-full rounded-xl bg-white px-3 pb-4 pt-3 lg:bottom-8 lg:!max-w-6xl lg:px-4 lg:pb-6 lg:pt-5'>
                        <div className='mb-3 flex w-full items-center gap-1'>
                            <IconCookie className='h-4 w-4 shrink-0' data-sentry-element="IconCookie" data-sentry-source-file="cookie-consent-modal.tsx" />
                            <span>تایید کوکی‌ها</span>

                            <IconClose className={'absolute left-3 h-6 w-6 cursor-pointer lg:left-4'} onClick={onDenied} data-sentry-element="IconClose" data-sentry-source-file="cookie-consent-modal.tsx" />
                        </div>
                        <div className='flex flex-col gap-6 lg:flex-row lg:items-center'>
                            <p className='shrink-0'>
                                خانومی برای بهبود تجربه شما از کوکی‌ها استفاده می‌کند. با انتخاب “تایید”، با{' '}
                                <AppNextLink target='_blank' href={'/privacy'} prefetch={false} className='text-alert-info-dark' data-sentry-element="AppNextLink" data-sentry-source-file="cookie-consent-modal.tsx">
                                    قوانین کوکی‌های ما{' '}
                                </AppNextLink>
                                موافقت می‌کنید.
                            </p>

                            <div className='flex w-full gap-4'>
                                <Button graphicStyle='filled' size={isMobile ? 'small' : 'medium'} onClick={onGranted} className='w-full' data-sentry-element="Button" data-sentry-source-file="cookie-consent-modal.tsx">
                                    تایید
                                </Button>
                                <Button graphicStyle='outlined' size={isMobile ? 'small' : 'medium'} onClick={onDenied} className='w-full' data-sentry-element="Button" data-sentry-source-file="cookie-consent-modal.tsx">
                                    رد کردن
                                </Button>
                            </div>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Transition>;
};
export default CookieConsentModal;